var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mention"},[(!_vm.cloudId)?_c('NcUserBubble',{attrs:{"display-name":_vm.name,"user":_vm.id}}):_c('strong',{attrs:{"title":_vm.cloudId}},[_vm._v("\n\t\t"+_vm._s(_vm.name)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }